import { API } from "aws-amplify";

export async function shorten(url: string): Promise<string> {
  try {
    
    const response = await API.post(
      'api-service',
      '/url/shorten',
      {
        body: {
          longUrl: url
        }
      }
    )

    return response.data.shortUrl
  } catch (error) {
    console.log(error);
    return url;
  }
}